// extracted by mini-css-extract-plugin
module.exports = {"logo":"sectionFooter-module--logo--36bLB"};